import React, { useEffect, useState } from 'react';

import { useParams, useNavigate } from 'react-router-dom';
import classNames from 'classnames';
import ASSETS from '../../assets';
import { bryt } from '../../http';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(utc);
dayjs.extend(relativeTime);

const BlockDetails = () => {
  const navigate = useNavigate();
  const [tab, setTab] = useState('overview');

  const blockNumber = useParams().id;

  const [block, setBlock] = useState(null);

  const handleTab = val => {
    setTab(val);
  };

  const handleFetchBlock = async () => {
    try {
      const res = await bryt.getBlockByBLockNumber(blockNumber);
      setBlock(res.result);
    } catch (err) {
      console.log(err.message);
    }
  };

  const handleViewTransactions = () => {
    navigate(`/block/${blockNumber}/transactions`, {
      state: block?.transactions,
    });
  };

  const renderTime = () => {
    const timestamp = block?.timestamp;
    // Convert the Unix timestamp to a JavaScript Date object
    const date = dayjs.unix(timestamp).utc();

    // Get the relative time
    const timeAgo = date.fromNow();

    // Format the date
    const formattedDate = date.format('MMM-DD-YYYY hh:mm:ss A [UTC]');

    return `${timeAgo} (${formattedDate})`;
  };

  useEffect(() => {
    handleFetchBlock();
    // eslint-disable-next-line
  }, [blockNumber]);

  return (
    <div className='flex-grow bg-blocks px-10 pt-5 pb-[174px]'>
      <div className='flex items-center gap-[6px]'>
        <p className='text-[19px] font-semibold'>Block</p>
        <p className='text-[14.5px] text-bryt-grey-700'>#{blockNumber}</p>
      </div>
      <div className='flex items-center gap-[10px] mt-1'>
        <div className='flex items-center gap-[3px] rounded-3xl border border-bryt-grey-300 py-[4.5px] px-[6px]'>
          <p className='text-[11px]'>#</p>
          <p className='text-[11px] font-semibold'>POM Block</p>
          <img src={ASSETS.info} alt='' />
        </div>
        {/* <div className='flex items-center gap-[3px] rounded-3xl border border-bryt-grey-300 py-[4.5px] px-[6px]'>
          <p className='text-[11px]'>#</p>
          <p className='text-[11px] font-semibold'>EigenPhi</p>
          <img src={ASSETS.info} alt='' />
        </div> */}
      </div>
      <div className='border-t border-t-bryt-grey-200 mt-[21px]'></div>
      <p className='text-[14.5px] text-bryt-primary-main mt-[14px] mb-9'>
        Use <span className='font-bold'>RYT SDK</span> for network
        communications
      </p>
      <div className='flex items-center gap-[7px] mb-3'>
        <button
          className={classNames(
            'py-[5px] px-[9px] bg-bryt-grey-200 rounded-lg text-bryt-primary-main',
            tab === 'overview' && 'text-white bg-bryt-primary-main'
          )}
          onClick={() => handleTab('overview')}
        >
          <p className='text-inherit text-[12.6px] font-semibold'>Overview</p>
        </button>
        {/* <button
          className={classNames(
            'py-[5px] px-[9px] bg-bryt-grey-200 rounded-lg text-bryt-primary-main',
            tab === 'consensus' && 'text-white bg-bryt-primary-main'
          )}
          onClick={() => handleTab('consensus')}
        >
          <p className='text-inherit text-[12.6px] font-semibold'>
            Consensus Info
          </p>
        </button> */}
      </div>
      <div className='bg-white px-[9px] py-5 border border-bryt-grey-200 rounded-[12px] shadow-txBox'>
        <div className='flex flex-col gap-[15px] px-2'>
          <div className='w-full grid grid-cols-12'>
            <div className='col-span-3 flex items-center gap-1'>
              <img src={ASSETS.infoGrey} className='w-[14.5px]' alt='' />
              <p className='text-[14.5px] text-bryt-grey-700'> Block Height:</p>
            </div>
            <div className='col-span-9'>
              <div className='flex items-center gap-1'>
                <p className='text-[14.5px]'>{blockNumber}</p>
                {/* <div className='w-6 h-6 bg-bryt-grey-200 rounded-[6px] grid place-items-center cursor-pointer'>
                  <img src={ASSETS.chevronLeft} alt='' />
                </div>
                <div className='w-6 h-6 bg-bryt-grey-200 rounded-[6px] grid place-items-center cursor-pointer'>
                  <img src={ASSETS.chevronRight} alt='' />
                </div> */}
              </div>
            </div>
          </div>
          <div className='w-full grid grid-cols-12'>
            <div className='col-span-3 flex items-center gap-1'>
              <img src={ASSETS.infoGrey} className='w-[14.5px]' alt='' />
              <p className='text-[14.5px] text-bryt-grey-700'> Status:</p>
            </div>
            <div className='col-span-9 flex'>
              <div className='flex items-center gap-1 border border-bryt-grey-200 bg-bryt-grey-100 px-2 py-[5px] rounded-[6px]'>
                <img src={ASSETS.check} alt='' />
                <p className='text-[11px] font-semibold'> Finalized</p>
              </div>
            </div>
          </div>
          <div className='w-full grid grid-cols-12'>
            <div className='col-span-3 flex items-center gap-1'>
              <img src={ASSETS.infoGrey} className='w-[14.5px]' alt='' />
              <p className='text-[14.5px] text-bryt-grey-700'> Timestamp:</p>
            </div>
            <div className='col-span-9'>
              <div className='flex items-center gap-1'>
                <img src={ASSETS.clock} alt='' />
                <p className='text-[14.5px]'>{renderTime()}</p>
              </div>
            </div>
          </div>
          <div className='w-full grid grid-cols-12'>
            <div className='col-span-3 flex items-center gap-1'>
              <img src={ASSETS.infoGrey} className='w-[14.5px]' alt='' />
              <p className='text-[14.5px] text-bryt-grey-700'> Proposed On:</p>
            </div>
            <div className='col-span-9'>
              <p className='text-[14.5px]'>Block proposed on slot</p>
            </div>
          </div>
          <div className='w-full grid grid-cols-12'>
            <div className='col-span-3 flex items-center gap-1'>
              <img src={ASSETS.infoGrey} className='w-[14.5px]' alt='' />
              <p className='text-[14.5px] text-bryt-grey-700'> Transactions:</p>
            </div>
            <div className='col-span-9'>
              {block?.transactions?.length > 0 ? (
                <p
                  className='text-[14.5px] cursor-pointer'
                  onClick={handleViewTransactions}
                >
                  {block?.transactions?.length || 0} transactions
                </p>
              ) : (
                <p className='text-[14.5px]'>
                  {block?.transactions?.length || 0} transactions
                </p>
              )}
            </div>
          </div>
          <div className='border-t border-t-bryt-grey-200 my-[5px]'></div>
          <div className='w-full grid grid-cols-12 px-2'>
            <div className='col-span-3 flex items-center gap-1'>
              <img src={ASSETS.infoGrey} className='w-[14.5px]' alt='' />
              <p className='text-[14.5px] text-bryt-grey-700'> Size:</p>
            </div>
            <div className='col-span-9'>
              <p className='text-[14.5px]'>106,848 bytes</p>
            </div>
          </div>
        </div>
      </div>
      <div className='flex items-start gap-[14.5px] mt-[14px]'>
        <img src={ASSETS.bulb} alt='' />
        <p className='text-[12.5px] text-bryt-grey-700'>
          Blocks are batches of transactions linked via cryptographic hashes.
          Any tampering of a block would invalidate all following blocks as all
          subsequent hashes would change. Learn more about this page in our{' '}
          <span className='text-bryt-primary-main'>Knowledge Base</span>
        </p>
      </div>
    </div>
  );
};

export default BlockDetails;
